<template>
    <Layout header-class="header-left-align bg-dark" nav-alignment="left" :show-top-header="false" :header-type="2"
        :footer-style="4">
        <div class="main-content">
            <iframe src="/otdr"></iframe>
        </div>
    </Layout>
</template>

<script>
import Layout from '@/components/common/Layout'

export default {
    name: 'otdr',
    components: { Layout }
}
</script>

<style scoped>
.main-content {
    height: calc(100vh - 80px);
}

.main-content iframe {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 0;
}
</style>